// frontend/src/components/landing/content.js
// Copy for the landing page sections.

// Order follows the pipeline stages in docs/API.md.
export const PIPELINE_AGENTS = [
  {
    key: "sentinel",
    name: "Sentinel",
    phase: "Understand",
    desc: "Reads your request, classifies the task and decides how much interviewing it really needs.",
  },
  {
    key: "scout",
    name: "Scout",
    phase: "Understand",
    desc: "Researches how experts frame this kind of task and recalls what PAWNI has already learned about it.",
  },
  {
    key: "architect",
    name: "Architect",
    phase: "Understand",
    desc: "Interviews you in short multiple-choice rounds until every essential prompt element is covered.",
  },
  {
    key: "forge",
    name: "Forge",
    phase: "Draft",
    desc: "Drafts a sample answer early, so gaps in the brief show up before the prompt is final.",
  },
  {
    key: "scribe",
    name: "Scribe",
    phase: "Draft",
    desc: "Writes the structured prompt from everything gathered: role, context, constraints, deliverables.",
  },
  {
    key: "judge",
    name: "Judge",
    phase: "Evaluate",
    desc: "Scores the prompt with a panel of models from different providers and reports where it falls short.",
  },
  {
    key: "mirror",
    name: "Mirror",
    phase: "Evaluate",
    desc: "Turns the panel's critique into concrete revisions and sends Scribe back for another pass.",
  },
  {
    key: "cipher",
    name: "Cipher",
    phase: "Deliver",
    desc: "Compiles the accepted prompt into POML markup, ready for tooling and version control.",
  },
];

export const FEATURES_LIST = [
  {
    title: "Self-evolving knowledge",
    desc: "Every run adds to a pattern file for its task type. Insights are reinforced, merged and pruned until the knowledge converges.",
  },
  {
    title: "Live streaming pipeline",
    desc: "Watch each agent work token by token. Nothing happens behind a spinner; you see the reasoning as it forms.",
  },
  {
    title: "Multi-model evaluation",
    desc: "A panel of judges from several providers scores every draft, so no single model's taste decides what “good” means.",
  },
  {
    title: "Jev fast decisions",
    desc: "A lightweight decision model handles classification, matching and coverage checks in a blink, keeping the heavy models for writing.",
  },
  {
    title: "Dual output: SAD + POML",
    desc: "Take a clean, readable prompt to paste anywhere, and a POML version for pipelines, templates and diffing.",
  },
  {
    title: "Step mode control",
    desc: "Pause after any agent, read what it produced, add a note, rerun or revert. You stay in charge of every stage.",
  },
];
